<template>
  <header class="topbar" style="position: fixed; width: 100%; z-index: 98">
    <nav
      class="navbar top-navbar navbar-expand-md navbar-light"
      style="padding: 0"
    >
      <div
        class="top-menu"
        style="
          float: right;
          max-height: 100px;
          display: flex;
          align-items: center;
        "
      >
        <div
          class="col-6"
          v-if="
            authUser.userable_type == 'investor' ||
            (authUser.userable_type == 'administrator' && investorID)
          "
        >
          <img
            style="width: 150px; cursor: pointer"
            :src="'data:image/png;base64,' + logo"
            alt=""
            @click="changeTab()"
          />
        </div>
        <div
          :class="
            authUser.userable_type == 'investor' ||
            (authUser.userable_type == 'administrator' && investorID)
              ? 'col-6'
              : 'col-12'
          "
          style="justify-content: end; display: flex"
        >
          <div style="display: flex; align-items: center">
            <h5
              v-if="
                authUser.userable_type == 'administrator' &&
                investorID &&
                activeInvestor
              "
              :style="
                checkIsMobile()
                  ? 'margin: 0; font-size: 14px'
                  : 'margin: 0; margin-right: 15px'
              "
              style="color: white"
            >
              {{ activeInvestor.title }}
              {{ activeInvestor.first_name }}
              {{ checkIsMobile() ? "" : activeInvestor.last_name }}
            </h5>
            <h5
              v-else
              :style="
                checkIsMobile()
                  ? 'margin: 0; font-size: 14px'
                  : 'margin: 0; margin-right: 15px'
              "
              style="color: white"
            >
              {{ authUser.userable.title }}
              {{ authUser.userable.first_name }}
              {{ checkIsMobile() ? "" : authUser.userable.last_name }}
            </h5>
            <div id="profileMenu">
              <div>
                <i
                  v-if="!authUser.userable.profile_picture"
                  style="
                    color: rgb(255 255 255);
                    padding: 15px;
                    font-size: 40px;
                    margin-right: 15px;
                    cursor: pointer;
                  "
                  @click="toggleProfileMenu()"
                  class="fa fa-user-circle"
                ></i>
                <div
                  v-else
                  style="
                    border-radius: 50%;
                    width: 45px;
                    height: 45px;
                    margin-right: 15px;
                    border: solid white 2px;
                    cursor: pointer;
                  "
                  @click="toggleProfileMenu()"
                >
                  <img
                    :src="
                      'data:image/' +
                      authUser.userable.profile_picture.extension +
                      ';base64,' +
                      authUser.userable.profile_picture.image
                    "
                    style="height: 100%; width: 100%; border-radius: 50%"
                    alt=""
                  />
                </div>
              </div>

              <div
                style="
                  position: absolute;
                  display: block;
                  background-color: #8cc63f;
                  min-width: 127px;
                  top: 95px;
                  right: 50px;
                "
              >
                <ul
                  style="padding: 15px; font-family: sans-serif"
                  class="no-bullets"
                  v-if="showProfileDropDownMenu"
                >
                  <li>
                    <router-link @click.native="redirectToProfile()" to=""
                      >Profile</router-link
                    >
                  </li>
                  <li
                    style="margin-top: 10px"
                    v-if="
                      authUser.userable_type == 'administrator' && investorID
                    "
                  >
                    <router-link @click.native="redirectToInvestor()" to=""
                      >Exit Investor</router-link
                    >
                  </li>
                  <li style="margin-top: 10px">
                    <router-link @click.native="signOut()" to=""
                      >Sign Out</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState } from "vuex";
import sweetAlert from "sweetalert2";
import StorageMediaFileFilter from "../filters/StorageMediaFileFilter";
import { getStorageMediaFile } from "../api/directapi";
import { EventBus } from "../event-bus";

export default {
  data() {
    return {
      showProfileDropDownMenu: false,
      logo: null,
      investorID: null,
    };
  },
  created: function () {
    if (
      this.$route.path ==
      "/administrator/investor/" +
        this.$route.params.investorCode +
        "/dashboard/" +
        this.$route.params.investorId
    ) {
      this.investorID = this.$route.params.investorId;
    }

    let storageMediaFileFilter = StorageMediaFileFilter();
    storageMediaFileFilter.names = ["YurBe_Logos_Logo_Small_White.png"];
    getStorageMediaFile(storageMediaFileFilter).then((response) => {
      this.logo = response.body.results.images.YurBe_Logos_Logo_Small_White;
    });
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      activeInvestor: (state) =>
        state.investorStore.investorSearch.investors[0],
    }),
  },
  components: {},
  methods: {
    checkIsMobile() {
      return window.innerWidth < 768;
    },
    toggleProfileMenu() {
      this.showProfileDropDownMenu = !this.showProfileDropDownMenu;
    },
    changeTab() {
      EventBus.$emit("changeTab", "dashboard");
    },
    closeMenu() {
      if (this.showProfileDropDownMenu) {
        this.showProfileDropDownMenu = false;
      }
    },

    signOut() {
      this.toggleProfileMenu();
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to sign out?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("logoutUser");
        }
      });
    },
    redirectToProfile() {
      this.toggleProfileMenu();
      this.$router.push("/" + this.authUser.userable_type + "/profile");
    },
    redirectToInvestor() {
      this.investorID = null;
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investor/" +
          this.$route.params.investorCode +
          "/" +
          this.$route.params.investorId
      );
    },
  },
  mounted: function () {
    let self = this;
    window.addEventListener("click", function (e) {
      if (!document.getElementById("profileMenu").contains(e.target)) {
        self.closeMenu();
      }
    });
  },
  beforeDestroy() {
    this.investorID = null;
  },
};
</script>

<style lang="scss">
.top-menu {
  width: 100%;
  min-height: 100px;
  background-color: #8cc63f;
  font-family: Caviar Dreams;
  font-size: 20px;
}
ul.no-bullets {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Navbar.vue